import { render, staticRenderFns } from "./moduleCreateEdit.vue?vue&type=template&id=2027e7ef&scoped=true&"
import script from "./moduleCreateEdit.vue?vue&type=script&lang=js&"
export * from "./moduleCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./moduleCreateEdit.vue?vue&type=style&index=0&id=2027e7ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2027e7ef",
  null
  
)

export default component.exports